"use strict";
/**
 * useResolvedDegreePlans - Resolves stub entities in DegreePlans using lookup maps
 *
 * Pure computation: replaces stub academicProgram, cohort, term, and course
 * objects with fully-hydrated objects from the lookup maps.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResolvedDegreePlans = useResolvedDegreePlans;
const react_1 = require("react");
function useResolvedDegreePlans(plans, termsMap, coursesMap, programsMap, cohortsMap) {
    return (0, react_1.useMemo)(() => {
        // Don't resolve if maps are empty (still loading)
        if (termsMap.size === 0 && coursesMap.size === 0 && programsMap.size === 0 && cohortsMap.size === 0) {
            return plans;
        }
        return plans.map(plan => {
            var _a, _b;
            const resolvedProgram = ((_a = plan.academicProgram) === null || _a === void 0 ? void 0 : _a.id)
                ? programsMap.get(plan.academicProgram.id) || plan.academicProgram
                : plan.academicProgram;
            let resolvedCohort = plan.cohort;
            if ((_b = plan.cohort) === null || _b === void 0 ? void 0 : _b.id) {
                const fullCohort = cohortsMap.get(plan.cohort.id);
                if (fullCohort) {
                    resolvedCohort = Object.assign(Object.assign({}, fullCohort), { program: plan.cohort.program || fullCohort.program, specialization: plan.cohort.specialization || fullCohort.specialization, track: plan.cohort.track || fullCohort.track });
                }
            }
            const resolvedTerms = plan.terms.map(termPlan => (Object.assign(Object.assign({}, termPlan), { term: termsMap.get(termPlan.term.id) || termPlan.term, courses: termPlan.courses.map(cp => (Object.assign(Object.assign({}, cp), { course: coursesMap.get(cp.course.id) || cp.course }))) })));
            return Object.assign(Object.assign({}, plan), { academicProgram: resolvedProgram, cohort: resolvedCohort, terms: resolvedTerms });
        });
    }, [plans, termsMap, coursesMap, programsMap, cohortsMap]);
}
